<template>
    <div class="container remove-padding-margin">
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"
                  v-if="isClickedloader === true"></span>
        </div>
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-1 col-sm-1 col-1 remove-padding" data-toggle="modal" data-target="#modalcancell">
                        <img class="remove-padding-margin" @click="" src="../../assets/img/x2.svg">
                    </div>
                    <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
                        <div class="remove-margin">Verifikasi Nomor WA Lama</div>
                    </div>
                    <div class="col-md-1 col-sm-1 col-1 remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="color-0000 font-16 line-height-25">Kode verifikasi telah dikirim ke <b>nomor WA lama</b> ({{telp_lama}}). Periksa Whatsapp Anda & masukkan kode dibawah. </div>
                    <div class="input-code">
                        <div class="row justify-content-center align-items-center remove-padding-margin col-md-12 col-sm-12 col-12 col-lg-12 offset-lg-12">
                            <div class="col-md-12 remove-padding">
	                            <InputOtp :bindButton="'#btnverifikasilama'" @onComplete="setOtpCode" />
                                <div class="col-12 remove-padding">
                                    <div class="code-otp color-8080 font-13 line-height-21 letter-space-002" id="textTimer">
                                        Masukkan Kode Sebelum <!--<span class="color-0000"><b><a id="countdown"></a></b></span>-->
	                                    <Countdown class="color-0000" :timeleft="timeleft" @callbackCountdown="countdownTimeout"
		                                    ref="countdown"/>
                                    </div>
                                    <div class="code-otp color-8080 font-13 line-height-21 letter-space-002" id="linkKirimUlang">
                                        Belum menerima kode ? <a style="color:#007bff" @click="submit(true)">Kirim
                                        Ulang Kode</a>
                                    </div>
                                    <div class="code-otp color-8080 font-13 line-height-21 letter-space-002" id="linkKirimUlangmorethan3">
                                        Belum menerima kode ? <a style="color:#007bff" @click="showmodalnotif">Kirim
                                        Ulang Kode</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long" id="btnverifikasilama" @click="submit(false)">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span>
                        <span id="textBtnverifikasilama">Berikutnya</span>
                    </button>
                </div>
            </div>
        </main>

        <div class="modal fade" id="modalcancell" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Batalkan Ubah Nomor</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Yakin ingin batal mengubah nomor WA? </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="back">Ya, Batalkan
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalnotif" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Cek Nomor Anda</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body add-padding-default mar-top-16 mar-bot-12">
                        <div class="font-16 color-33333 line-height-25 letter-space-002">Kami telah beberapa kali mengirim kode verifikasi. Pastikan Anda <b>memiliki akses</b> akun whatsapp <b>{{telp_lama}}</b> untuk menerima kode verifikasi.</div>
                    </div>
                    <div class="add-padding-default mar-bottom-20">
                        <div class="font-16 color-33333 line-height-25 letter-space-002 remove-margin mar-bot-12">Tidak punya akses ke nomor tersebut?</div>
                        <div class="font-14 font-weight-600 letter-space-002 line-height-25 color-206CF remove-margin" @click="pusatbantuan">Kunjungi pusat bantuan <span><img
                                src="../../assets/icons/ic_baseline-arrow-back.svg" alt=""></span></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalwrongsend" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Cek Nomor Anda</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body add-padding-default mar-top-16 mar-bot-12">
                        <div class="font-16 color-33333 line-height-25 letter-space-002">Anda telah beberapa kali memasukkan kode verifikasi yang salah. Pastikan Anda <b>memiliki akses</b> akun whatsapp <b>{{telp_lama}}</b> untuk menerima kode verifikasi.</div>
                    </div>
                    <div class="add-padding-default mar-bottom-20">
                        <div class="font-16 color-33333 line-height-25 letter-space-002 remove-margin mar-bot-12">Tidak punya akses ke nomor tersebut?</div>
                        <div class="font-14 font-weight-600 letter-space-002 line-height-25 color-206CF remove-margin"  @click="pusatbantuan">Kunjungi pusat bantuan <span><img
                                src="../../assets/icons/ic_baseline-arrow-back.svg" alt=""></span></div>
                    </div>
                </div>
            </div>
        </div>
	    <vue-recaptcha
		    ref="recaptcha"
		    @verify="onCaptchaVerified"
		    @expired="onCaptchaExpired"
		    size="invisible"
		    sitekey="6Lc_X9QZAAAAAI0vmQNzNDQG-rKZ7NOE0O3wq5W9">
	    </vue-recaptcha>

    </div>
</template>

<script>
	import InputOtp from "../../component-items/InputOtp";
	import Countdown from "../../component-items/Countdown";
	import VueRecaptcha from "vue-recaptcha"

    export default {
        name: "VerifikasiNomorLama",
	    components: { InputOtp, Countdown, 'vue-recaptcha': VueRecaptcha },
        data(){
            return{
                telp_lama:'',
                telp_new:'',
                dataLoop: 1,
                datasendotp:0,
                dataError:0,
                isClicked:false,
                isClickedloader:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
				timeleft: 0,
	            otp: "",
	
	            sendOTPAgain: false,
            }
        },
        mounted(){
	        let recaptchaScript = document.createElement('script')
	        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
	        document.head.appendChild(recaptchaScript)
        	
            $('#loadingPage').removeClass('overlayLoading')
            var telpLocal = "+" + localStorage.getItem("telp");
            this.telp_lama = telpLocal;
            var telpLocalnew = "+" + localStorage.getItem("telpBaru");
            this.telp_new = telpLocalnew;
            $('#linkKirimUlang').hide();
            $('#linkKirimUlangmorethan3').hide();
            $('.first').focus();
            $('#countdown').text("2.00");
            $('#close').hide()
	        
	        this.timeleft = 120;
	
	        $('body').on('DOMSubtreeModified', '.grecaptcha-badge', function(){
		        $(".grecaptcha-badge").hide()
	        });
        },
        methods:{
            back(){
                this.$router.push('/loginownerwa')
            },
	
	        submit(tipe) {
            	if (tipe) {
		            this.sendOTPAgain = true;
	            } else {
		            this.sendOTPAgain = false;
	            }
		        // this.$refs.recaptcha.execute();
            if (this.sendOTPAgain) {
              this.getotplama("null")
            } else {
              this.sendOTPlama("null")
            }
	        },
	        onCaptchaVerified: function (recaptchaToken) {
            	if (this.sendOTPAgain) {
		            this.getotplama(recaptchaToken)
	            } else {
            		this.sendOTPlama(recaptchaToken)
	            }
		        const self = this;
		        self.$refs.recaptcha.reset();
	        },
	        onCaptchaExpired: function () {
		        this.$refs.recaptcha.reset();
	        },

            next(){
                this.$router.push('/verifikasinomorbaru')
            },

            pusatbantuan(){
                this.$router.push('/pusatbantuan')
            },

            async sendOTPlama(recaptchaToken){
                this.isClicked = true;
                $('#textBtnverifikasilama').hide()
                var telpStr = this.telp_lama
                var replaceTelp = telpStr.replace(/-/g, "");
                var replaceSpace = replaceTelp.replace(/\s/g, "");
                var fixTelp = replaceSpace.replace(/\+/g, "");
                var codeval = this.otp;
              try {
                  const dataOtp = new FormData;
                  dataOtp.append('nomor_wa_lama', fixTelp);
                  dataOtp.append('kode_otp', codeval);
                  dataOtp.append("token_captcha", recaptchaToken)
                  const res = await this.$axios.post(this.$baseurl + '/masterData/owner/verifikasi_otp_nomor_lama_owner', dataOtp,this.requestHeaders)
                  if(res.data.status===true){
                      this.isClicked = false;
                      $('#textBtnverifikasilama').show();
                      this.getotpbaru(recaptchaToken)
	                  $("#btnverifikasilama").prop("disabled", false)
                  }else{
                      this.isClicked = false;
                      var loopsed = this.datasendotp + 1;
                      this.datasendotp = loopsed;
                      if(loopsed>=3){
                          $('#modalwrongsend').modal('show')
                      }else if(loopsed<3){
	                      this.$toast.error(res.data.msg)
                      }
                      this.isClicked = false;
                      $('#textBtnverifikasilama').show()
                      $('#btnverifikasilama').prop('disabled', false);
                  }
              }  catch (e) {
	              $('#loadingPage').removeClass('overlayLoading');
	              this.isClickedloader = false
              	
	              this.$catch_error_response(e)
	
	              $('#loadingPage').removeClass('overlayLoading');
	              this.isClicked = false
	              $('#textBtnverifikasilama').show()
	              $('#btnverifikasilama').prop('disabled', false);
              }
            },

            async getotpbaru(recaptchaToken){
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                var telpStr = this.telp_new;
                var replaceTelp = telpStr.replace(/-/g, "");
                var replaceSpace = replaceTelp.replace(/\s/g, "");
                var fixTelp = replaceSpace.replace(/\+/g, "");
                try {
                    const dataOtpnew = new FormData;
                    dataOtpnew.append('nomor_wa_baru', fixTelp);
	                dataOtpnew.append("token_captcha", recaptchaToken)
                    const res = await this.$axios.post(this.$baseurl + '/masterData/owner/kirim_otp_nomor_baru_owner', dataOtpnew,this.requestHeaders)
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false;
                        this.dataError = 0;
                        this.next();
                    }else{
	                    $('#loadingPage').removeClass('overlayLoading');
	                    this.isClickedloader = false;
                    	
	                    this.$toast.error(res.data.msg)
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	
	                if (dataCountError < 3){
		                var dataCountErrorNew = dataCountError + 1;
		                this.dataError = dataCountErrorNew;
		                this.getotpbaru()
	                }
                }
            },

            showmodalnotif(){
                var looping = this.dataLoop;
                if (looping > 3) {
                    $('#modalnotif').modal('show');
                    $('#textTimer').hide();
                    $('#linkKirimUlangmorethan3').show();
                    $('#linkKirimUlang').hide();
                } else{
                    $('#countdown').text("2.00");
                    $('#linkKirimUlang').hide();
                    $('#textTimer').show();
                }
            },

            async getotplama(recaptchaToken){
	            $('#loadingPage').addClass('overlayLoading');
	            this.isClickedloader = true;

                try {
                    var noTelp = localStorage.getItem("telp");
                    var noTelpnew = localStorage.getItem("telpBaru");
                    const dataOtp = new FormData;
                    dataOtp.append('nomor_wa_lama', noTelp);
                    dataOtp.append('nomor_wa_baru', noTelpnew);
	                dataOtp.append("token_captcha", recaptchaToken)
                    const res = await this.$axios.post(this.$baseurl + '/masterData/owner/kirim_otp_nomor_lama_owner', dataOtp,this.requestHeaders)
                    if(res.data.status===true){
	                    $('#loadingPage').removeClass('overlayLoading');
	                    this.isClickedloader = false;

	                    this.timeleft = 120
	                    $("#linkKirimUlang").hide();
	                    $("#textTimer").show();

                        var loop = this.dataLoop + 1;
                        this.dataLoop = loop;
                        this.dataError = 0;
                        this.showmodalnotif()
                    }else{
	                    $('#loadingPage').removeClass('overlayLoading');
	                    this.isClickedloader = false

	                    this.$toast.error(res.data.msg)
                    }

                }catch (e) {
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
                	
	                this.$catch_error_response(e)
                }
            },
	        countdownTimeout() {
		        this.timeleft = 0;
		
		        if (this.dataLoop === 3) {
			        $('#modalwrongsend').modal('show');
		        }
		
		        $('#textTimer').hide();
		        $('#linkKirimUlang').show();
	        },
	        setOtpCode(otp) {
		        this.otp = otp
		
		        // direct
		        this.submit(false)
	        },
        }
    }
</script>

<style scoped>

</style>